import React from 'react';
import { Box } from '@material-ui/core';
import { EmojiEvents, FiberNew } from '@material-ui/icons';
import { Badge } from '../../../../../common/badges/Badge';
import { BadgeDesign, DEFAULT_BADGE_DESIGN } from '../../../../../common/badges/badge-svg';

const parseDesign = (json: string | null): BadgeDesign | null => {
  if (!json) return null;
  try {
    return { ...DEFAULT_BADGE_DESIGN, ...JSON.parse(json) };
  } catch (e) {
    return null;
  }
};

interface Props {
  badgeDesign: string | null;
  label: string;
  size: number;
  held?: boolean;
  isNew?: boolean;
}

export const AchievementBadge = ({ badgeDesign, label, size, held = true, isNew }: Props) => {
  const design = parseDesign(badgeDesign);
  return (
    <Box position='relative' lineHeight={0}>
      <Box style={held ? undefined : { filter: 'grayscale(1)', opacity: 0.32 }}>
        {design ? (
          <Badge design={design} size={size} label={label} />
        ) : (
          <Box
            width={size}
            height={size}
            borderRadius='50%'
            bgcolor='#F2F2F2'
            color='#9E9E9E'
            display='flex'
            alignItems='center'
            justifyContent='center'
          >
            <EmojiEvents />
          </Box>
        )}
      </Box>
      {isNew && (
        <FiberNew
          titleAccess='New'
          style={{
            position: 'absolute',
            top: -8,
            right: -4,
            color: '#FF7705',
            fontSize: 22,
          }}
        />
      )}
    </Box>
  );
};
